import { t as __t } from "i18next";
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import SmartTable from '../../components/common/table-component';
import DashboardHeader from '../../components/header/DashboardHeader';
import MobileMenu from '../../components/header/MobileMenu';
import DashboardEmployerSidebar from '../../components/header/DashboardSidebar';
import CopyrightFooter from '../../components/footer/employers/CopyrightFooter';
import { t } from 'i18next';
import insuranceType from "../../data/insuranceType";
import DatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import { callSearchAgentInfo } from '../../api/settings/service';
import { useDispatch, useSelector } from 'react-redux';
import DataAutoComplete from "../../components/auto-complete";
import { callApproveCommission, callGetCommissionDetails, callGetCommissionDetailsByAgentId } from '../../api/contract/service';
import colors from '../../utils/colors';
import PermissionWrapper from '../../components/common/PermissionWrapper';
import { APPROVE } from '../../utils/commonType';
import SwalAlert from '../../components/common/alert';
import itemsCommision from '../../data/statusCommision';
import './commission-ui-only.css';
import { findLoggedAgent, getCommissionAgentScope } from './commissionAgentScope';

const CommissionDetailPage = () => {
    const userInfo = useSelector((state) => state.dataLogin);
    const dispatch = useDispatch();
    const agentScope = getCommissionAgentScope(userInfo);
    const isAgentUser = agentScope.isAgentUser;
    const loggedAgentId = agentScope.agentId;
    const [agentData, setAgentData] = useState(agentScope.initialAgent);
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);

    const [request, setRequest] = useState({
        page: 1,
        maxResult: 10,
        keyword: '',
        startDate: startOfMonth,
        endDate: new Date(),
        insuranceType: 1,
        agentId: "",
        status: ""
    });

    const [agent, setAgent] = useState([]);
    const [data, setData] = useState({
        result: [],
        totalRecords: 0,
        totalPages: 1,
        sumRecords: 0,
    });

    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [approvalRequest, setApprovalRequest] = useState({
        page: 1,
        maxResult: 10,
        keyword: '',
        startDate: startOfMonth,
        endDate: new Date(),
        insuranceType: 1,
        agentId: isAgentUser ? loggedAgentId : "",
    });
    const [approvalAgent, setApprovalAgent] = useState([]);
    const [approvalSearched, setApprovalSearched] = useState(false);
    const [approvalAgentError, setApprovalAgentError] = useState(false);
    const [approvalData, setApprovalData] = useState({
        result: [],
        totalRecords: 0,
        totalPages: 1,
        sumRecords: 0,
    });
    const [approvalResetSelectedKey, setApprovalResetSelectedKey] = useState(0);
    const [approvalLoading, setApprovalLoading] = useState(false);
    const [refreshMainAfterApproval, setRefreshMainAfterApproval] = useState(false);

    useEffect(() => {
        const initializeAgentScope = async () => {
            if (isAgentUser) {
                if (!loggedAgentId) {
                    setData({ result: [], totalRecords: 0, totalPages: 1, sumRecords: 0 });
                    return;
                }

                const lockedAgent = await findLoggedAgent({
                    dispatch,
                    callSearchAgentInfo,
                    scope: agentScope,
                });

                if (lockedAgent) {
                    setAgentData(lockedAgent);
                    setAgent([lockedAgent]);
                }

                setRequest((prev) => ({
                    ...prev,
                    page: 1,
                    agentId: loggedAgentId,
                }));

                await loadDataCom({ page: 1, agentId: loggedAgentId });
                return;
            }

            setAgentData(null);
            await loadDataCom({ page: 1 });
        };

        initializeAgentScope();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAgentUser, loggedAgentId, agentScope.agentCode]);

    const columns = [
        {
            label: 'agentFullName',
            key: 'agentFullName',
            style: { minWidth: 180 },
        },
        {
            label: 'agentCode',
            key: 'agentCode',
            style: { minWidth: 100 },
        },
        {
            label: 'custFullName',
            key: 'custFullName',
            style: { minWidth: 180 },
        },
        {
            label: 'insuranceType',
            key: 'insuranceType',
            style: { minWidth: 120 },
            render: (value) => (
                <span style={{ color: colors.primary, fontWeight: 700 }}>
                    {t('insuranceType.' + value)}
                </span>
            ),
        },
        {
            label: 'contractNumber',
            key: 'contractNumber',
            style: { minWidth: 120 },
        },
        {
            label: 'billNumber',
            key: 'billNumber',
            style: { minWidth: 180 },
        },
        {
            label: 'commissionAmount',
            key: 'commissionAmount',
            className: 'text-end',
            style: { minWidth: 120 },
            render: (value) => (
                <span style={{ color: colors.primary, fontWeight: 700 }}>
                    {Number(value || 0).toLocaleString()}
                </span>
            ),
        },
        {
            label: 'companyReceiveTotal',
            key: 'companyReceiveTotal',
            className: 'text-end',
            style: { minWidth: 120 },
            render: (value) => (
                <span style={{ color: colors.primary, fontWeight: 700 }}>
                    {Number(value || 0).toLocaleString()}
                </span>
            ),
        },
        {
            label: 'earnedDate',
            key: 'earnedDate',
            style: { minWidth: 150 },
            render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        },
        {
            label: 'status',
            key: 'status',
            style: { minWidth: 120 },
            render: (value) => {
                if (Number(value) === 0) {
                    return <span className="badge bg-warning text-dark">{t("status.eearned")}</span>;
                }
                if (Number(value) === 1) {
                    return <span className="badge bg-info">{t("status.approved")}</span>;
                }
                if (Number(value) === 2) {
                    return <span className="badge bg-secondary">{t("status.inPayout")}</span>;
                }
                if (Number(value) === 3) {
                    return <span className="badge bg-success">{t("status.paid")}</span>;
                }
                if (Number(value) === 4) {
                    return <span className="badge bg-danger">{t("status.cancelled")}</span>;
                }
                return <span className="badge bg-light text-dark">{value}</span>;
            },
        },
    ];

    const approvalColumns = columns;

    const getApprovalRequest = (params = {}) => ({
        ...approvalRequest,
        ...params,
        ...(isAgentUser ? { agentId: loggedAgentId } : {}),
    });

    // The commission API supports status arrays, so the approval popup can
    // load Pending Approval (0) and Cancelled (4) in one request.
    const loadApprovalData = async (params = {}) => {
        const approvalParams = getApprovalRequest(params);
        if (!approvalParams.agentId) {
            setApprovalAgentError(true);
            return;
        }

        try {
            setApprovalLoading(true);

            const rsp = await dispatch(callGetCommissionDetails({
                ...approvalParams,
                status: [0, 4],
            }));
            console.log(rsp?.payload?.data)
            if (rsp?.payload?.responseCode === "00000") {
                setApprovalData(rsp?.payload?.data || {
                    result: [],
                    totalRecords: 0,
                    totalPages: 1,
                    sumRecords: [],
                });
            } else {
                setApprovalData({
                    result: [],
                    totalRecords: 0,
                    totalPages: 1,
                    sumRecords: [],
                });
            }
        } finally {
            setApprovalLoading(false);
        }
    };

    const openApprovalModal = async () => {
        const defaultAgentId = isAgentUser ? loggedAgentId : "";
        const modalRequest = {
            page: 1,
            maxResult: 10,
            keyword: '',
            startDate: startOfMonth,
            endDate: new Date(),
            insuranceType: request.insuranceType || 1,
            agentId: defaultAgentId,
        };

        setApprovalRequest(modalRequest);
        setApprovalAgent(agentData ? [agentData] : []);
        setApprovalData({ result: [], totalRecords: 0, totalPages: 1, sumRecords: 0 });
        setApprovalSearched(isAgentUser && Boolean(defaultAgentId));
        setApprovalAgentError(isAgentUser && !defaultAgentId);
        setApprovalResetSelectedKey((prev) => prev + 1);
        setRefreshMainAfterApproval(false);
        setShowApprovalModal(true);

        if (isAgentUser && defaultAgentId) {
            await loadApprovalData(modalRequest);
        }
    };

    const closeApprovalModal = async () => {
        setShowApprovalModal(false);
        setApprovalSearched(false);
        setApprovalAgentError(false);
        setApprovalResetSelectedKey((prev) => prev + 1);

        if (refreshMainAfterApproval) {
            setRefreshMainAfterApproval(false);
            await loadDataCom();
        }
    };

    const loadApprovalAgents = async (value) => {
        if (isAgentUser) {
            setApprovalAgent(agentData ? [agentData] : []);
            return;
        }

        const rsp = await dispatch(callSearchAgentInfo({
            keyword: value?.id ? null : value,
            page: 1,
            maxResult: value?.id ? 1 : 10,
            agentId: value?.id || null,
        }));

        if (rsp?.payload?.responseCode === "00000") {
            setApprovalAgent(rsp?.payload?.data?.result || []);
        } else {
            setApprovalAgent([]);
        }
    };

    const onSelectApprovalAgent = (item) => {
        if (isAgentUser) return;

        const agentId = item?.agentId || "";
        setApprovalRequest((prev) => ({
            ...prev,
            page: 1,
            agentId,
        }));
        setApprovalAgentError(!agentId);
        setApprovalSearched(false);
        setApprovalData({ result: [], totalRecords: 0, totalPages: 1, sumRecords: 0 });
        setApprovalResetSelectedKey((prev) => prev + 1);
    };

    const onSearchApproval = async (e) => {
        e?.preventDefault?.();

        if (!approvalRequest.agentId) {
            setApprovalAgentError(true);
            setApprovalSearched(false);
            return;
        }

        setApprovalAgentError(false);
        setApprovalSearched(true);
        setApprovalResetSelectedKey((prev) => prev + 1);
        await loadApprovalData({ page: 1 });
    };

    const handleApprove = async (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return;

        SwalAlert.confirm(t("swal.title.approve"), t("swal.text.confirmApprove"), async () => {
            try {
                const rsp = await dispatch(callApproveCommission({ id: ids }));
                if (rsp?.payload?.responseCode === "00000") {
                    setApprovalResetSelectedKey((prev) => prev + 1);

                    if (showApprovalModal) {
                        // Refresh only the popup here. The main list is refreshed once when
                        // the popup closes, so one user action does not fire duplicate list APIs.
                        setRefreshMainAfterApproval(true);
                        await loadApprovalData({ page: 1 });
                    } else {
                        await loadDataCom();
                    }
                } else {
                    SwalAlert.error(
                        __t("uiText.text023"),
                        rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription
                    );
                }
            } catch (error) {
                SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"));
            }
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prev) => ({ ...prev, [name]: value }));
    };

    const onSearch = async (e) => {
        e.preventDefault();
        loadDataCom();
    };

    const loadDataCom = async (params = {}) => {
        const requestParams = {
            ...request,
            ...params,
            ...(isAgentUser ? { agentId: loggedAgentId } : {}),
        };
        if (isAgentUser && !loggedAgentId) return;

        const rsp = await dispatch(callGetCommissionDetails(requestParams));
        if (rsp?.payload?.responseCode === "00000") {
            setData(rsp.payload.data);
        }
    };

    const loadData = async (value) => {
        if (isAgentUser) {
            if (!loggedAgentId) return;
            const lockedAgent = await findLoggedAgent({
                dispatch,
                callSearchAgentInfo,
                scope: agentScope,
            });
            if (lockedAgent) {
                setAgentData(lockedAgent);
                setAgent([lockedAgent]);
            }
            return;
        }

        if (value?.id) {
            const rsp = await dispatch(callSearchAgentInfo({
                keyword: null,
                page: 1,
                maxResult: 1,
                agentId: value?.id
            }));
            if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
                setAgent(rsp.payload.data.result);
            }
        } else {
            const rsp = await dispatch(callSearchAgentInfo({
                keyword: value,
                page: 1,
                maxResult: 10,
                agentId: null
            }));
            if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
                setAgent(rsp.payload.data.result);
            }
        }
    };

    const onSelect = async (item) => {
        if (isAgentUser) {
            setRequest((prev) => ({
                ...prev,
                agentId: loggedAgentId,
            }));
            return;
        }

        setRequest((prev) => ({
            ...prev,
            agentId: item ? item.agentId : null,
        }));
    };

    return (
        <div className="page-wrapper dashboard commission-ui-only">
            <span className="header-span"></span>
            <DashboardHeader />
            <MobileMenu />
            <DashboardEmployerSidebar />

            <section className="user-dashboard">
                <div className="dashboard-outer">
                    <div className="upper-title-box commission-page-title">
                        <div>
                            <h4>{t("menu.commission.commissionDetail")}</h4>
                            <div className="commission-page-subtitle">
                                {t("commission.listViewOnlyDescription")}
                            </div>
                        </div>

                        <PermissionWrapper permission={APPROVE}>
                            <button
                                type="button"
                                className="btn btn-primary commission-approve-open-btn"
                                onClick={openApprovalModal}
                            >
                                <i className="fas fa-check-circle me-2"></i>
                                {t("commission.approveCommission")}
                            </button>
                        </PermissionWrapper>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="ls-widget commission-card">
                                <div className="tabs-box">
                                    <div className="widget-content p-4">
                                        <div className="default-form commission-form">
                                            <div className="row">
                                                <div className="col-md-3 form-group">
                                                    <label>{t('contracts.life.agentCode')}</label>
                                                    <DataAutoComplete
                                                        disabled={isAgentUser}
                                                        label="firstName"
                                                        id="agentCode"
                                                        initialData={agentData}
                                                        data={agent}
                                                        autoSelect={true}
                                                        placeholder={t('contract.keyword')}
                                                        handleChange={loadData}
                                                        onSelect={onSelect}
                                                    />
                                                </div>

                                                <div className="col-md-3 form-group">
                                                    <label>{t('startDate')}</label>
                                                    <DatePicker
                                                        selected={request.startDate}
                                                        onChange={(date) => setRequest((prev) => ({
                                                            ...prev,
                                                            startDate: date,
                                                        }))}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText={t('startDate')}
                                                        className="form-control-uld"
                                                    />
                                                </div>

                                                <div className="col-md-3 form-group">
                                                    <label>{t('endDate')}</label>
                                                    <DatePicker
                                                        selected={request.endDate}
                                                        onChange={(date) => setRequest((prev) => ({
                                                            ...prev,
                                                            endDate: date,
                                                        }))}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText={t('endDate')}
                                                        className="form-control-uld"
                                                    />
                                                </div>

                                                <div className="col-md-3 form-group">
                                                    <label>{t('callcenter.payment.insuranceType')}</label>
                                                    <select
                                                        className="chosen-single form-select"
                                                        onChange={handleChange}
                                                        name="insuranceType"
                                                        value={request.insuranceType}
                                                    >
                                                        {insuranceType.map((item) => (
                                                            <option key={item.id} value={item.id}>{t(item.name)}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-3 form-group">
                                                    <label>{t('status.text')}</label>
                                                    <select
                                                        className="chosen-single form-select"
                                                        onChange={handleChange}
                                                        name="status"
                                                        value={request.status}
                                                    >
                                                        <option key={0} value="">{t("selectedAll")}</option>
                                                        {itemsCommision.map((item) => (
                                                            <option key={item.id} value={item.key}>{t(item.name)}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-12 form-group justify-content-center d-flex">
                                                    <div className="col-md-3 form-group">
                                                        <button
                                                            type="button"
                                                            className="theme-btn btn-style-one w-100 commission-search-btn"
                                                            onClick={onSearch}
                                                        >
                                                            <i className="fas fa-search"></i>&nbsp;{t("button.search")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="ls-widget commission-card">
                                <div className="tabs-box">
                                    <div className="widget-content p-4">
                                        <div className="commission-view-only-note">
                                            <i className="fas fa-eye"></i>
                                            <span>{t("commission.listViewOnlyHint")}</span>
                                        </div>

                                        <SmartTable
                                            showSumRecord={false}
                                            columns={columns}
                                            data={data}
                                            onLazyLoad={(params) => loadDataCom(params)}
                                            recordsTableFilter={true}
                                            customPagination={true}
                                            selectable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CopyrightFooter />

            <Modal
                show={showApprovalModal}
                onHide={closeApprovalModal}
                size="xl"
                centered
                backdrop="static"
                dialogClassName="commission-approval-modal"
            >
                <Modal.Header closeButton className="commission-approval-modal-header">
                    <div>
                        <Modal.Title>{t("commission.approveCommission")}</Modal.Title>
                        <div className="commission-modal-subtitle">
                            {t("commission.approvalModalDescription")}
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="commission-approval-modal-body">
                    <div className="commission-approval-filter-box">
                        <div className="commission-approval-filter-title">
                            <div className="commission-approval-filter-icon">
                                <i className="fas fa-filter"></i>
                            </div>
                            <div>
                                <strong>{t("commission.approvalFilterTitle")}</strong>
                                <div>{t("commission.approvalFilterDescription")}</div>
                            </div>
                        </div>

                        <div className="row commission-approval-filter-form">
                            <div className="col-lg-3 col-md-6 form-group">
                                <label>
                                    {t('contracts.life.agentCode')}
                                    <span className="commission-required">*</span>
                                </label>
                                <div className={approvalAgentError ? 'commission-field-error' : ''}>
                                    {isAgentUser && loggedAgentId ? (
                                        <div className="commission-readonly-agent">
                                            <i className="fas fa-user-check"></i>
                                            <span>
                                                {agentData?.agentCode || agentScope.agentCode || loggedAgentId}
                                                {' - '}
                                                {[agentData?.firstName || agentScope.firstName, agentData?.lastName || agentScope.lastName]
                                                    .filter(Boolean)
                                                    .join(' ') || '-'}
                                            </span>
                                        </div>
                                    ) : (
                                        <DataAutoComplete
                                            label="firstName"
                                            id="agentCode"
                                            data={approvalAgent}
                                            autoSelect={true}
                                            placeholder={t('commission.selectAgentPlaceholder')}
                                            handleChange={loadApprovalAgents}
                                            onSelect={onSelectApprovalAgent}
                                        />
                                    )}
                                </div>
                                {approvalAgentError && (
                                    <div className="commission-validation-message">
                                        <i className="fas fa-exclamation-circle"></i>
                                        {t("commission.agentRequired")}
                                    </div>
                                )}
                            </div>

                            <div className="col-lg-3 col-md-6 form-group">
                                <label>{t('startDate')}</label>
                                <DatePicker
                                    selected={approvalRequest.startDate}
                                    onChange={(date) => {
                                        setApprovalRequest((prev) => ({ ...prev, page: 1, startDate: date }));
                                        setApprovalSearched(false);
                                    }}
                                    selectsStart
                                    startDate={approvalRequest.startDate}
                                    endDate={approvalRequest.endDate}
                                    maxDate={approvalRequest.endDate || undefined}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText={t('startDate')}
                                    className="form-control-uld"
                                />
                            </div>

                            <div className="col-lg-3 col-md-6 form-group">
                                <label>{t('endDate')}</label>
                                <DatePicker
                                    selected={approvalRequest.endDate}
                                    onChange={(date) => {
                                        setApprovalRequest((prev) => ({ ...prev, page: 1, endDate: date }));
                                        setApprovalSearched(false);
                                    }}
                                    selectsEnd
                                    startDate={approvalRequest.startDate}
                                    endDate={approvalRequest.endDate}
                                    minDate={approvalRequest.startDate || undefined}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText={t('endDate')}
                                    className="form-control-uld"
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>{t('callcenter.payment.insuranceType')}</label>
                                <select
                                    className="chosen-single form-select"
                                    onChange={(data) => {
                                        setApprovalRequest((prev) => ({ ...prev, page: 1, insuranceType: data.target.value }));
                                    }}
                                    name="insuranceType"
                                    value={approvalRequest.insuranceType}
                                >
                                    {insuranceType.map((item) => (
                                        <option key={item.id} value={item.id}>{t(item.name)}</option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ marginTop: 18 }} className="col-md-12 form-group justify-content-center d-flex">
                                <div className="col-md-3 form-group">                                <button
                                    type="button"
                                    className="btn btn-primary commission-approval-search-btn"
                                    onClick={onSearchApproval}
                                    disabled={approvalLoading}
                                >
                                    <i className="fas fa-search"></i>
                                    {t("button.search")}
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!approvalSearched ? (
                        <div className="commission-approval-empty-state">
                            <div className="commission-approval-empty-icon">
                                <i className="fas fa-user-check"></i>
                            </div>
                            <strong>{t("commission.approvalSelectAgentFirst")}</strong>
                            <span>{t("commission.approvalSelectAgentFirstDescription")}</span>
                        </div>
                    ) : approvalLoading && approvalData?.result?.length === 0 ? (
                        <div className="commission-approval-loading">
                            <div className="spinner-border text-success" role="status" aria-hidden="true"></div>
                            <span>{t("uiText.text017")}</span>
                        </div>
                    ) : (
                        <SmartTable
                            showSumRecord={false}
                            resetSelectedKey={approvalResetSelectedKey}
                            columns={approvalColumns}
                            data={approvalData}
                            onLazyLoad={(params) => approvalSearched && loadApprovalData(params)}
                            selectable={true}
                            rowKey="id"
                            statusCheck={['0']}
                            statusColKey="status"
                            recordsTableFilter={true}
                            customPagination={true}
                            onConfirmSelected={({ ids }) => handleApprove(ids)}
                            confirmButtonLabel="commission.approveSelected"
                            onLoadSelectAll={async () => {
                                if (!approvalRequest.agentId) {
                                    setApprovalAgentError(true);
                                    return { ids: [] };
                                }
                                const rsp = await dispatch(callGetCommissionDetailsByAgentId({
                                    startDate: approvalRequest.startDate,
                                    endDate: approvalRequest.endDate,
                                    agentId: isAgentUser ? loggedAgentId : approvalRequest.agentId,
                                    status: 0,
                                    type: approvalRequest.insuranceType,
                                }));
                                if (rsp?.payload?.responseCode === "00000") {
                                    return { ids: rsp?.payload?.data };
                                }
                                return { ids: [] };
                            }}
                        />
                    )}
                </Modal.Body>

                <Modal.Footer className="commission-approval-modal-footer">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={closeApprovalModal}
                    >
                        {t("button.close")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CommissionDetailPage;
